export default "__VITE_ASSET__Dr4ErVG6__"